import { ChangeAreaComponent } from "./change-area/change-area.component"
import { DetailComponent } from "./detail/detail.component"
import { DocumentTagComponent } from "./document-tag/document-tag.component"
import { EditableDetailComponent } from "./editable-detail/editable-detail.component"
import { FloatingButtonComponent } from "./floating-button/floating-button.component"
import { HeaderComponent } from "./header/header.component"
import { NotificationsComponent } from "./notifications/notifications.component"
import { PaginationComponent } from "./pagination/pagination.component"
import { PushNotificationsComponent } from "./push-notifications/push-notifications.component"
import { SidebarComponent } from "./sidebar/sidebar.component"
import { WizardStepButtonsComponent } from "./wizard-step-buttons/wizard-step-buttons.component"
import { inputs } from "./input"
import { modals } from "./modals"
import { userProfileComponents } from "./user-profile"

export {
  ChangeAreaComponent,
  DetailComponent,
  DocumentTagComponent,
  EditableDetailComponent,
  FloatingButtonComponent,
  HeaderComponent,
  NotificationsComponent,
  PaginationComponent,
  PushNotificationsComponent,
  SidebarComponent,
  WizardStepButtonsComponent,
}

import { DriverSelectComponent } from './driver-select/driver-select.component';
import { VehicleSelectComponent } from './vehicle-select/vehicle-select.component';
import { Select2OptionComponent } from './select2-option/select2-option.component';

export const sharedComponents = [
  ChangeAreaComponent,
  DetailComponent,
  DriverSelectComponent,
  VehicleSelectComponent,
  Select2OptionComponent,
  DocumentTagComponent,
  EditableDetailComponent,
  FloatingButtonComponent,
  HeaderComponent,
  ...inputs,
  ...modals,
  NotificationsComponent,
  PaginationComponent,
  PushNotificationsComponent,
  SidebarComponent,
  WizardStepButtonsComponent,
  ...userProfileComponents
]